import { render, staticRenderFns } from "./ConfirmationCode.vue?vue&type=template&id=fc565040&scoped=true"
import script from "./ConfirmationCode.vue?vue&type=script&lang=js"
export * from "./ConfirmationCode.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationCode.vue?vue&type=style&index=0&id=fc565040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc565040",
  null
  
)

export default component.exports